

// Check if a file is an image
export const isImageFile = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase();
    return ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp', 'heic', 'heif'].includes(ext || '');
};

// Check if a file is a video
export const isVideoFile = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase();
    return ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'm4v'].includes(ext || '');
};

// Clean directory prefix helper
export const cleanDirectoryPath = (dirId: string) => {
    if (dirId === 'files') return null;
    return dirId.replace(/^files\//, '') + '/';
};
